export enum QuestionColumnCellEnum {
  checkbox = 'checkbox',
}
